import React, { useState, useRef, useEffect, useMemo, useCallback} from 'react';

import { AgGridReact } from 'ag-grid-react'; // the AG Grid React Component
import 'ag-grid-enterprise';

import 'ag-grid-enterprise/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-enterprise/styles/ag-theme-alpine.min.css'; // Optional theme CSS

import ButtonDeviceInfoRenderer from './ButtonDeviceInfoRenderer';
import { useUser } from '../hooks/UserContext';

const ReadsPage = () => {

 const gridRef = useRef(); // Optional - for accessing Grid's API
 const [rowData, setRowData] = useState();

 const { user } = useUser();
 
 let isUserAdmin = 0
 try {
  const u = user ? (typeof user === 'string' ? JSON.parse(user) : user) : {};
  if (u.isAdmin !== undefined) isUserAdmin = u.isAdmin;
 } catch(e) {}

 // Each Column Definition results in one Column.
 const [columnDefs] = useState([
  
   // { headerName: 'Row ID', valueGetter: 'node.id' },
   { field: 'Action', cellRenderer: ButtonDeviceInfoRenderer, hide: isUserAdmin !== 1 }, 
    {field: 'dt', width: 250, },
    {field: 'wfmc'},
    {field: 'type'},
    {field: 'val'},
    {field: 'units'},
    {field: 'hw_type'}, 
    {field: 'org'},   
    {field: 'rwmc'},
    {field: 'ver'},
    {field: 'local_ip', headerName: 'ip'},
 ]);
 

 // DefaultColDef sets props common to all Columns
 const defaultColDef = useMemo( ()=> ({
    // flex: 1,
     sortable: true, 
     filter: 'agTextColumnFilter',
     enableRowGroup: true,
     menuTabs : ['filterMenuTab', 'generalMenuTab'],
     floatingFilter: true,
   }));

   const statusBarDefs = {
    statusPanels: [
      {
        statusPanel: 'agTotalAndFilteredRowCountComponent',
        align: 'left',
      },
      {
        statusPanel: 'agTotalRowCountComponent',
        align: 'left',
      },
      { statusPanel: 'agFilteredRowCountComponent' },
      { statusPanel: 'agSelectedRowCountComponent' },
      // { statusPanel: 'agAggregationComponent' },
    ],
  }
  
  function isRefreshEnabledSelected() {
    return document.querySelector('#refreshEnabled').checked;
  }
  
 // Example of consuming Grid Event
 const cellClickedListener = useCallback( event => {
   console.log('cellClicked', event);
 }, []);

 const refreshGridData = () => {
  if(isRefreshEnabledSelected()){ 
    fetch(`${window.location.origin}/reads?action=all&minutes_back=15`)
      .then(response => response.json())
      .then(data => setRowData(data))
      .catch(error => console.error(error));
  }
};

 // Example load data from sever
 useEffect(() => {
    
    const intervalId = setInterval(refreshGridData, 5 * 1000);
    return () => clearInterval(intervalId);
  
    
 }, []);
 return (
   <div style={{ height: '100%', width: '100%', }} >

     {/* Example using Grid's API */}
     
      <label htmlFor="refreshEnabled">
        <input type="checkbox" id="refreshEnabled" defaultChecked />
        Refresh Every 5 Seconds
      </label>
      &nbsp;
      
      &nbsp;&nbsp;&nbsp;&nbsp; 
      Data for last 15 minutes
     {/* <button onClick={buttonListener}>Refresh</button> */}

     {/* On div wrapping Grid a) specify theme CSS Class Class and b) sets Grid size */}
     <div className="ag-theme-alpine-dark" style={{ height: '100%', width: '100%', }} >
      
     <AgGridReact style={{ height: '100%', width: '100%', }} 
           ref={gridRef} // Ref for accessing Grid's API

           rowData={rowData} // Row Data for Rows

           columnDefs={columnDefs} // Column Defs for Columns
           defaultColDef={defaultColDef} // Default Column Properties

           // animateRows={true} // Optional - set to 'true' to have rows animate when sorted
           rowSelection='multiple' // Options - allows click selection of rows

           onCellClicked={cellClickedListener} // Optional - registering for Grid Event

           rowGroupPanelShow = 'always'
          
            statusBar = {statusBarDefs}
            pagination = 'true'
            // rowDragManaged = 'true'
            enableColumnAutosize = 'true'
            enableCellChangeFlash = 'true'
            enableCellTextSelection = 'true'
            // enableCharts = 'true'
            // enableRangeSelection = 'true'
            // immutableData = 'true'
           />
     </div>
   </div>
 );
};

export default ReadsPage;